﻿import { FunctionComponent } from "react";
import { Button, Flex, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { IconChevronRight } from "@tabler/icons-react";

type WidgetHeadingProps = {
    title: string;
    url?: string;
    linkText?: string;
};

export const WidgetHeading: FunctionComponent<WidgetHeadingProps> = ({ title, url, linkText }) => {
    const navigate = useNavigate();

    return (
        <Flex gap={"1rem"} pb={".5rem"} alignItems={"center"} justifyContent={"space-between"}>
            <Heading mb={0} variant={"cardHeading"}>
                {title}
            </Heading>
            {url && (
                <Button
                    variant={"ghost"}
                    px={0}
                    _hover={{ bg: "transparent" }}
                    fontWeight={"regular"}
                    rightIcon={<IconChevronRight />}
                    aria-label={`Go To ${title}`}
                    onClick={() => navigate(url)}
                    fontSize={"sm"}
                >
                    {linkText ? linkText : "View All"}
                </Button>
            )}
        </Flex>
    );
};
